module.exports = __webpack_public_path__ + "6a212c83288a31ef0b7e222f2cc532ec.svg";